export default "__VITE_ASSET__Djo94bJY__"